import e from "./ghl-ui.es1506.js";
import t from "./ghl-ui.es1466.js";
function u(r) {
  return t(1, arguments), e(r).getFullYear();
}
export {
  u as default
};
